import React, { useState } from "react";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import { BLOCOS_MANUAIS, TRIBUTO_NOME } from "../mockDataSemanal";
import { num, brl } from "../utils/formatters";
import LancamentoManualModal from "../modals/LancamentoManualModal";

/**
 * Lançamentos manuais da semana — substitui os inputs fixos do protótipo
 * por um botão "Adicionar parâmetro" + tabela do que foi incluído.
 */
export default function ManualEntriesPanel({ semanaNome, lancamentos, efeitos, obs, onAdd, onRemove, onObs }) {
  const [modalOpen, setModalOpen] = useState(false);

  const blocoTitulo = (id) => BLOCOS_MANUAIS.find((b) => b.id === id)?.titulo || id;

  return (
    <div className="panel-card manual-panel">
      <div className="panel-head">
        <div>
          <h5>Lançamentos manuais · {semanaNome}</h5>
          <p className="panel-sub">
            Os mesmos campos da aba IMPOSTOS. Cada valor entra no débito ou no
            crédito do tributo e muda o resultado da semana e do mês.
          </p>
        </div>
        <button type="button" className="btn-primary" onClick={() => setModalOpen(true)}>
          <FiPlus /> Adicionar parâmetro
        </button>
      </div>

      <div className="tablewrap">
        <table className="apura-table">
          <thead>
            <tr>
              <th>Bloco</th>
              <th>Tributo</th>
              <th>Efeito</th>
              <th className="r">Valor</th>
              <th className="r"></th>
            </tr>
          </thead>
          <tbody>
            {lancamentos.length === 0 ? (
              <tr>
                <td colSpan={5} className="empty-cell">
                  Nenhum parâmetro adicionado nesta semana.
                </td>
              </tr>
            ) : (
              lancamentos.map((l) => (
                <tr key={l.id}>
                  <td>{blocoTitulo(l.blocoId)}</td>
                  <td>{TRIBUTO_NOME[l.tributo]}</td>
                  <td className="muted">{l.efeito}</td>
                  <td className={`r ${l.valor ? "man" : ""}`}>{num(l.valor)}</td>
                  <td className="r">
                    <button
                      type="button"
                      className="row-remove"
                      onClick={() => onRemove(l.id)}
                      aria-label="Remover lançamento"
                    >
                      <FiTrash2 />
                    </button>
                  </td>
                </tr>
              ))
            )}
            <tr className="row-total">
              <td colSpan={3}>Efeito no total da semana</td>
              <td className={`r res ${efeitos.total < -0.005 ? "neg" : ""}`}>
                {Math.abs(efeitos.total) < 0.005
                  ? "–"
                  : `${efeitos.total < 0 ? "Reduz " : "Aumenta "} ${brl(Math.abs(efeitos.total))}`}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="obs-field">
        <label htmlFor="obs-semana">Observação da semana (motivo dos lançamentos)</label>
        <input
          id="obs-semana"
          type="text"
          maxLength={200}
          value={obs || ""}
          onChange={(e) => onObs(e.target.value)}
          placeholder="Ex.: saldo credor conforme apuração do mês anterior"
        />
      </div>

      <LancamentoManualModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onAdd={onAdd}
        semanaNome={semanaNome}
      />
    </div>
  );
}
